module.exports = __webpack_public_path__ + "dbzc-icon.png?717c4607929efe13241bf301ac8270aa";


//////////////////
// WEBPACK FOOTER
// ./static/assets/dbzc-icon.png
// module id = 42
// module chunks = 0